import { render, staticRenderFns } from "./WordUnitModule.vue?vue&type=template&id=08946509&scoped=true&"
import script from "./WordUnitModule.vue?vue&type=script&lang=js&"
export * from "./WordUnitModule.vue?vue&type=script&lang=js&"
import style0 from "./WordUnitModule.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WordUnitModule.vue?vue&type=style&index=1&id=08946509&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08946509",
  null
  
)

component.options.__file = "WordUnitModule.vue"
export default component.exports